import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { SuspendCardConfirm } from './SuspendCardConfirm';
import { SuspendCardPlaced } from './SuspendCardPlaced';

import { SuspendCardStackParamList, SuspendCardStackRoutes } from './type';

const SuspendCardStack = createNativeStackNavigator<SuspendCardStackParamList>();

export const SuspendCardNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.SuspendCard>> = ({ route }) => {
  const { account, tab, record, func, actionResponse, actionError, refresh } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const [data, setData] = useState<any>(undefined);
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const onData = (value: any) => {
    setData(value);
  };

  return (
    <ModalContainerView dimensions={dimensions} nativeFlag={false}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <SuspendCardStack.Navigator
          initialRouteName={SuspendCardStackRoutes.Confirm}
          screenOptions={{
            presentation: 'transparentModal',
            headerShown: false,
            contentStyle: {
              backgroundColor: 'transparent'
            }
          }}>
          <SuspendCardStack.Screen
            name={SuspendCardStackRoutes.Confirm}
            component={SuspendCardConfirm}
            initialParams={{ onLayout, account, tab, record, func, actionResponse, actionError, onData, refresh }}
            options={{ headerShown: false }}
          />
          <SuspendCardStack.Screen
            name={SuspendCardStackRoutes.Placed}
            component={SuspendCardPlaced}
            initialParams={{ onLayout, account, tab, record, data, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </SuspendCardStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
